import apiService from './ApiService';

const downloadBlob = async (endpoint, fallbackName) => {
  const baseURL = apiService.baseURL;
  const headers = apiService.getAuthHeaders();
  const response = await fetch(`${baseURL}${endpoint}`, { headers });
  if (!response.ok) throw new Error('Error descargando archivo');
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename="?(.+?)"?$/i);
  const fileName = match ? match[1] : fallbackName;
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const SolicitudesProcesosService = {
  async getCount() {
    return apiService.get('/solicitudes-procesos/count');
  },

  async getSolicitudes({ page = 1, pageSize = 20, search = '' } = {}) {
    let url = `/solicitudes-procesos?page=${page}&pageSize=${pageSize}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return apiService.get(url);
  },

  async marcarLeido(id) {
    return apiService.put(`/solicitudes-procesos/${id}/leido`, {});
  },

  async finalizar(id, url) {
    return apiService.put(`/solicitudes-procesos/${id}/finalizar`, { url });
  },

  async getArchivos(procesoId) {
    return apiService.get(`/solicitudes-procesos/${procesoId}/archivos`);
  },

  async downloadFile(procesoId, fileId, fileName) {
    return downloadBlob(
      `/solicitudes-procesos/${procesoId}/archivos/${fileId}/download`,
      fileName || 'archivo'
    );
  },

  async downloadAllFiles(procesoId) {
    return downloadBlob(
      `/solicitudes-procesos/${procesoId}/archivos/download-zip`,
      `archivos-solicitud.zip`
    );
  },

  async getAcciones(procesoId) {
    return apiService.get(`/solicitudes-procesos/${procesoId}/acciones`);
  },
};

export default SolicitudesProcesosService;
